/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const meetingDataTypeSchema = z.enum([
	'jobilla_meet',
	'google_meet',
	'teams',
	'zoom',
	'phone',
	'in_person',
	'custom',
])

export type MeetingDataTypeSchema = z.infer<typeof meetingDataTypeSchema>
